import { render } from "./LoFiRadio.vue?vue&type=template&id=5f798438"
import script from "./LoFiRadio.vue?vue&type=script&lang=js"
export * from "./LoFiRadio.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__